import { httpClient } from '../http/httpClient'
import { PartnerType } from '@/app/utils/partners.enum'
import { TriStateEnum } from '@/app/entities/TriState'

export type ProductItem = {
  _id?: string
  label: string | number
  value: number
  max?: number
  type?: string
}

export type ProductDetail = {
  name: string;
  delay: number;
  isActive: boolean;
  _id: string;
  state: TriStateEnum;
  itens: ProductItem[];
  tableId?: string;
  createLink?: boolean;
  label?: string;
  subtitle?: string;
  image?: string;
  color?: string;
};

export type ProductsDetails = {
  [key in PartnerType]: ProductDetail
}

export type ProductsConfigResponseNew = {
  products: ProductsDetails
} & Record<PartnerType, boolean>

export async function getProductsConfig() {
  const { data } =
    await httpClient.get<ProductsConfigResponseNew>('config/products')

  return data
}
